import { all, call, put, take } from 'redux-saga/effects';
import { get } from 'lodash';
import { notification } from 'antd';

import { CREATE_PATIENT_ACCOUNT } from '../type';
import {
  createPatientAccountErrorAction,
  createPatientAccountSuccessAction,
} from '../action';

import MessengerResource from 'common/resource/MessengerResource';

import { accountService } from 'services';

function* createAccount() {
  while (1) {
    const action = yield take(CREATE_PATIENT_ACCOUNT);
    try {
      const callback = get(action, 'payload.callback');
      const response = yield call(
        accountService.createPatientAccount,
        action.payload,
      );

      callback && callback(response);

      yield put(createPatientAccountSuccessAction(response));
    } catch (error) {
      notification.error({
        message: MessengerResource.account.createAccountFail,
        description: error.message,
      });
      yield put(createPatientAccountErrorAction(error));
    }
  }
}

export default function* rootSaga() {
  yield all([createAccount()]);
}
